import { Box, makeStyles } from "@material-ui/core";

import { Icon } from "../../components/base";
import { COLORS } from "../../theme/colors";

const useStyles = makeStyles(() => ({
  root: {
    width: 72,
    height: 72,
    border: `4px solid ${COLORS.darks[0][6]}`,
    borderRadius: 100,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: COLORS.white,
  },
}));

export const NOIIconBox = ({ src, rootStyle }) => {
  const classes = useStyles();

  return (
    <Box className={classes.root} style={rootStyle}>
      <Icon src={src} />
    </Box>
  );
};
